import script from "./mobileCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./mobileCheck.vue?vue&type=script&setup=true&lang=js"

import "./mobileCheck.vue?vue&type=style&index=0&id=353166b1&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-353166b1"]])

export default __exports__